import React, { useEffect, useState } from 'react'

import { Log } from 'services/apiTypes/deck.types'

import { useAppSelector } from 'app-redux/hooks'

import DeckService from 'services/deck.service'

import RecentChangeRow from 'components/deckPage/deckHistory/recentChangeRow'
import LineLoader from 'components/elements/LineLoader'

import styles from './recentChanges.module.scss'

const RecentChanges = () => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [logs, setLogs] = useState(new Array<Log>())

  const deckId = useAppSelector(state => state.deck.id)

  useEffect(() => {
    DeckService.getRecentLogs(deckId)
      .then(setLogs)
      .catch(setError)
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <LineLoader />
  if (error) return <div>Some error occured when fetching your decks added and removed cards</div>

  return (
    <div className={styles.container}>
      <h4>Most Recent 100 Changes</h4>
      <p>For more changes past 100, check out Added/Removed cards</p>
      {logs.map((log, index) => (
        <RecentChangeRow key={index} log={log} />
      ))}
    </div>
  )
}

export default RecentChanges
